
import axios from "axios";
// import { API_BASE_URL } from "../environment";

export const getActiveApiKey = async () => {
  try {
    const response = await axios.get(`/hris/api-keys/active`);
    console.log("getActiveApiKey full response:", JSON.stringify(response, null, 2));
    if (!response.data.apiKey?.key) {
      throw new Error("No valid API key returned from server");
    }
    return response.data.apiKey.key;
  } catch (error) {
    const errorDetails = error.response
      ? `Status: ${error.response.status}, Data: ${JSON.stringify(error.response.data)}`
      : error.message;
    console.error(`Error fetching active API key: ${errorDetails}`);
    throw new Error(`Failed to fetch API key: ${errorDetails}`);
  }
};

// Fetch employees using the API key
export const getHRISEmployees = async (lastUpdatedAfter = null) => {
  try {
    const apiKey = await getActiveApiKey();
    console.log("Using API key for employees request:", apiKey);
    const params = {};
    if (lastUpdatedAfter) params.last_updated_after = lastUpdatedAfter;

    const response = await axios.get(`/hris/employees`, {
      params,
      headers: {
        apikey: apiKey, // Use apikey header instead
      },
    });
    console.log("getHRISEmployees response:", response.data);
    return response.data;
  } catch (error) {
    const errorDetails = error.response
      ? `Status: ${error.response.status}, Data: ${JSON.stringify(error.response.data)}`
      : error.message;
    console.error(`Error fetching HRIS employees: ${errorDetails}`);
    throw new Error(`Failed to fetch employees: ${errorDetails}`);
  }
};

// export const syncHRISEmployee = async (employeeData) => {
//   try {
//     const response = await axios.post(`/hris/sync`, employeeData, {
//       headers: {
//         'x-api-key': localStorage.getItem('hris_api_key')
//       }
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error syncing HRIS employee:", error);
//     throw error;
//   }
// };

export const generateHRISApiKey = async (keyData) => {
  try {
    const response = await axios.post(`/hris/api-keys`, keyData);
    return response.data;
  } catch (error) {
    console.error("Error generating API key:", error);
    throw error;
  }
};

export const revokeHRISApiKey = async (keyValue) => {
  try {
    const response = await axios.delete(`/hris/api-keys/${keyValue}`);
    return response.data;
  } catch (error) {
    console.error("Error revoking API key:", error);
    throw error;
  }
};

  export const getAllApiKeys = async () => {
    try {
      const response = await axios.get(`/hris/api-keys`);
      return response.data;
    } catch (error) {
      console.error("Error generating API key:", error);
      throw error;
    }
  };